// One implementation lives in @shared/hooks; this path is kept for useSidebar.
export { useMediaQuery } from "@shared/hooks/useMediaQuery";
